import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { IMaskModule } from 'angular-imask';
import { DynamicFieldValidation } from '../../models/dynamic-field-form';

@Component({
    selector: 'app-dynamic-field-validations-form',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        IMaskModule,
    ],
    templateUrl: './dynamic-field-validations-form.component.html'
})
export class DynamicFieldValidationsFormComponent {
    @Input({ required: true }) validationsCtrl: FormArray<FormGroup<DynamicFieldValidation>>;

    private excluded = ['required', 'email', 'awbValidator', 'invalid', 'multiple', 'preventedHTMLStr'];

    showValidationSettings(validationName: string | null | undefined): boolean {
        if (!validationName) return false;
        return !this.excluded.includes(validationName);
    }

    getValidationValueControl(
        validationCtrl: AbstractControl
    ): FormControl<string | RegExp | string[] | RegExp[] | null> | null {
        return validationCtrl.get('value') as FormControl<string | RegExp | string[] | RegExp[] | null> | null;
    }

    getValidationValueType(validationCtrl: AbstractControl): string {
        return validationCtrl.get('name')?.value === 'pattern' ? 'text' : 'number';
    }

    showPatternFormatError(validationCtrl: AbstractControl): boolean {
        const name = validationCtrl.get('name')?.value;
        if (name !== 'pattern') return false;
        const valueCtrl = this.getValidationValueControl(validationCtrl);
        return !!(valueCtrl && valueCtrl.touched && valueCtrl.errors && valueCtrl.errors['patternInvalid']);
    }

    getValidationError(validationCtrl: AbstractControl): string | null {
        const valueCtrl = validationCtrl.get('value') as FormControl<
            string | RegExp | string[] | RegExp[] | null
        > | null;
        if (!valueCtrl || !valueCtrl.errors) return null;
        if (valueCtrl.errors['required']) return 'Value is required';
        if (valueCtrl.errors['patternInvalid']) return 'Invalid pattern';
        if (valueCtrl.errors['pattern']) return 'Only numbers are allowed';
        return null;
    }

    getValidationIMask(validationCtrl: AbstractControl): { mask: RegExp } | null {
        const name = validationCtrl.get('name')?.value;
        if (name === 'pattern') {
            return { mask: /^[^\r\n]*$/ };
        }
        return null;
    }
}
